export const date = new Date();

// Layout constants
export const HEADER_HEIGHT = 88;
export const HEADER_SPACING = 32;
export const DRAWER_WIDTH = 220;

export const gender = [
  {
    label: 'Male',
    value: 'MALE',
  },
  {
    label: 'Female',
    value: 'FEMALE',
  },
];

export const koreanBanks = [
  { label: '선택 안함', value: '' },
  { label: 'KB국민은행', value: 'KB국민은행' },
  { label: '신한은행', value: '신한은행' },
  { label: '우리은행', value: '우리은행' },
  { label: '하나은행', value: '하나은행' },
  { label: 'IBK기업은행', value: 'IBK기업은행' },
  { label: 'NH농협은행', value: 'NH농협은행' },
  { label: '카카오뱅크', value: '카카오뱅크' },
  { label: '토스뱅크', value: '토스뱅크' },
  { label: '케이뱅크', value: '케이뱅크' },
  { label: 'SC제일은행', value: 'SC제일은행' },
  { label: '씨티은행', value: '씨티은행' },
  { label: 'DGB대구은행', value: 'DGB대구은행' },
  { label: 'BNK부산은행', value: 'BNK부산은행' },
  { label: 'BNK경남은행', value: 'BNK경남은행' },
  { label: '광주은행', value: '광주은행' },
  { label: '전북은행', value: '전북은행' },
  { label: '제주은행', value: '제주은행' },
  { label: '수협은행', value: '수협은행' },
  { label: '신협', value: '신협' },
  { label: '새마을금고', value: '새마을금고' },
  { label: '우체국', value: '우체국' },
  { label: 'KDB산업은행', value: 'KDB산업은행' },
  { label: 'SBI저축은행', value: 'SBI저축은행' },
];

export const businessDivision = [
  {
    label: '개인',
    value: 'INDIVIDUAL',
  },
  {
    label: '법인',
    value: 'CORPORATION',
  },
];
export const accountStatus = [
  {
    label: 'APPROVAL_PENDING',
    value: 'APPROVAL_PENDING',
  },
  {
    label: 'APPROVED',
    value: 'APPROVED',
  },
  {
    label: 'REFUSED',
    value: 'REFUSED',
  },
  {
    label: 'WITHDREW',
    value: 'WITHDREW',
  },
];
export const employeeClassification = [
  {
    label: 'Employed',
    value: 'WORKING',
  },
  {
    label: 'Resigned',
    value: 'LEFT',
  },
];

export const employeeLoginYn = [
  {
    label: '가능',
    value: 'Y',
  },
  {
    label: '불가능',
    value: 'N',
  },
];

export const Respo = [
  { label: 'PRIVATE_LESSON', value: 'PRIVATE_LESSON' },
  { label: 'GROUP_LESSON', value: 'GROUP_LESSON' },
  { label: 'CUSTOMER_MANAGEMENT', value: 'CUSTOMER_MANAGEMENT' },
  { label: 'STORE_MANAGEMENT', value: 'STORE_MANAGEMENT' },
];

export const sportOptions = [
  {
    label: 'Fitness',
    value: 'FITNESS',
  },
  {
    label: 'Pilates',
    value: 'PILATES',
  },
  {
    label: 'Golf',
    value: 'GOLF',
  },
  {
    label: 'Crossfit',
    value: 'CROSSFIT',
  },
  {
    label: 'Yoga',
    value: 'YOGA',
  },
  {
    label: 'Ball games',
    value: 'BALL_GAMES',
  },
  {
    label: 'Boxing',
    value: 'BOXING',
  },
  {
    label: 'Dance',
    value: 'DANCE',
  },
  {
    label: 'Swimming',
    value: 'SWIMMING',
  },
  {
    label: 'Cycle',
    value: 'CYCLE',
  },
  {
    label: 'Tanning',
    value: 'TANNING',
  },
  {
    label: 'Stretching',
    value: 'STRETCHING',
  },
];

export const staffResponsibilities = [
  {
    label: '고객 관리, ',
    value: 'customerCare',
  },
  {
    label: '그룹 레슨, ',
    value: 'groupLessons',
  },
  {
    label: '개인 레슨, ',
    value: 'privateLessons',
  },
  {
    label: 'Center management, ',
    value: 'storeManagement',
  },
  {
    label: '온라인 레슨, ',
    value: 'onlineLessons',
  },
];

export const smsAgreement = [
  {
    label: 'Agree',
    value: true,
  },
  {
    label: 'Disagree',
    value: false,
  },
];

export const order = [
  {
    label: 'In regular order',
    value: 'ASCENDING',
  },
  {
    label: 'Reverse order',
    value: 'DESCENDING',
  },
];

export const sort = [
  {
    label: 'Most recent',
    value: 'LATEST',
  },
  {
    label: 'Sort by price',
    value: 'PRICE',
  },
];

export const sort1 = [
  {
    label: 'Most recent',
    value: 'LATEST',
  },
  {
    label: 'Sort by price',
    value: 'PRICE',
  },
  {
    label: 'Sort by number of uses',
    value: 'USAGE_COUNT ',
  },
];

export const size = [
  {
    label: 'Display 20 results per page',
    value: '20',
  },
  {
    label: '50개씩 보기',
    value: '50',
  },
  {
    label: '100개씩 보기',
    value: '100',
  },
];

export const employeStatus = [
  {
    label: '재직중',
    value: 'WORKING',
  },
  {
    label: '퇴사',
    value: 'LEFT',
  },
];
export const classTypes = [
  {
    label: 'Private lesson',
    value: 'PRIVATE_LESSON',
  },
  {
    label: 'GROUP_LESSON',
    value: 'GROUP_LESSON',
  },
  {
    label: 'OT',
    value: 'OT',
  },
];

export const salesStatus = [
  {
    label: '판매중',
    value: 'APPROVED',
  },
  {
    label: '판매 종료',
    value: 'EXPIRED',
  },
  // {
  //   label: '승인 반려',
  //   value: 'REFUSED',
  // },
];

export const timer = {
  hours: [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
  ],
  minutes: [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
  ],
};

export const scriptUrl = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';

export const weekDays = [
  {
    day: 1,
    name: 'Mon',
  },
  {
    day: 2,
    name: 'Tue',
  },
  {
    day: 3,
    name: 'Wed',
  },
  {
    day: 4,
    name: 'Thu',
  },
  {
    day: 5,
    name: 'Fri',
  },
  {
    day: 6,
    name: 'Sat',
  },
  {
    day: 0,
    name: 'Sun',
  },
];

export const facilities = [
  { facilityName: 'shower' },
  { facilityName: 'cafe' },
  { facilityName: 'locker' },
  { facilityName: 'fitting room' },
  { facilityName: 'private room' },
  { facilityName: 'parking lot' },
  { facilityName: 'balet' },
  { facilityName: 'sportswear' },
  { facilityName: 'towel' },
  { facilityName: 'aerobic equipment' },
  { facilityName: 'group lesson' },
  { facilityName: 'private lessons' },
  { facilityName: 'women only' },
];

export const createPointDefaults = {
  businessName: '',
  businessNumber: '',
  businessType: '',
  orgNumber: '',
  email_1: '',
  jibunAddress: '',
  roadAddress: '',
  webSite: '',
  fullname: '',
  username: '',
  password: '',
  verifyPassword: '',
  phoneNumber: '',
  email: '',
};

export const pageSize = [
  { label: '10개씩', value: 10 },
  { label: '50개씩', value: 50 },
  { label: '100개씩', value: 100 },
];
export const options = [
  { value: 20, label: '20 초' },
  { value: 30, label: '30 초' },
  { value: 60, label: '60 초' },
  { value: 120, label: '2 분' },
  { value: 180, label: '3 분' },
  { value: 300, label: '5 분' },
  { value: 480, label: '8 분' },
  { value: 600, label: '10 분' },
  { value: 900, label: '15 분' },
  { value: 1200, label: '20 분' },
  { value: 1800, label: '30 분' },
];

export const activeYn = [
  { label: 'ACTIVE', value: 'ACTIVE' },
  { label: 'INACTIVE', value: 'INACTIVE' },
];

export const memberTypes = [
  { value: 'ACTIVE', label: 'ACTIVE' },
  { value: 'STOPPED', label: 'STOPPED' },
  { value: 'EXPIRED', label: 'EXPIRED' },
  { value: 'WITHDREW', label: 'WITHDREW' },
];

export const ageRange = [
  { value: 'UNDER_20', label: 'UNDER_20' },
  { value: 'AGE_20_30', label: 'AGE_20_30' },
  { value: 'AGE_40_50', label: 'AGE_40_50' },
  { value: 'AGE_50_60', label: 'AGE_50_60' },
  { value: 'OVER_60', label: 'OVER_60' },
];

export const remainingCountsDef = [
  { value: 'UNDER_3', label: 'UNDER_3' },
  { value: 'UNDER_5', label: 'UNDER_5' },
  { value: 'UNDER_10', label: 'UNDER_10' },
];

export const daysButtons = [
  { label: 'Within 5 days', value: 5 },
  { label: 'Within 15 days', value: 15 },
  { label: 'Within this month', value: 0 },
  { label: 'Within next month', value: 1 },
];

export const monthButtons = [
  { label: '1 month', value: 1 },
  { label: '3 month', value: 3 },
  { label: '6 month', value: 6 },
  { label: '12 month', value: 12 },
  { label: 'Direct input', value: 1 },
];

export const passOptions = [
  { label: 'GENERAL', value: 'GENERAL' },
  { label: 'KIOSK', value: 'KIOSK' },
  { label: 'NON_MEMBER', value: 'NON_MEMBER' },
];

export const responsibilities = [
  { label: 'PRIVATE_LESSON', value: 'PRIVATE_LESSON' },
  { label: 'GROUP_LESSON', value: 'GROUP_LESSON' },
  { label: 'ONLINE_LESSON', value: 'ONLINE_LESSON' },
  { label: 'CUSTOMER_MANAGEMENT', value: 'CUSTOMER_MANAGEMENT' },
  { label: 'STORE_MANAGEMENT ', value: 'STORE_MANAGEMENT' },
];

export const cellStatus = [
  { label: 'TICKET_APPROVED', value: 'APPROVED' },
  { label: 'TICKET_EXPIRED', value: 'EXPIRED' },
  // { label: 'TICKET_REFUSED', value: '-' },
];

export const classifications = [
  { label: 'WORKING', value: 'WORKING' },
  { label: 'LEFT', value: 'LEFT' },
];

export const lessonFeeOptions = [
  { value: '', label: '가격대를 선택해주세요' },
  { value: 'UNDER_1', label: '1만원 이하' },
  { value: 'OVER_1_UNDER_2', label: '1만원 ~ 2만원' },
  { value: 'OVER_2_UNDER_4', label: '2만원 ~ 4만원' },
  { value: 'OVER_4_UNDER_6', label: '4만원 ~ 6만원' },
  { value: 'OVER_6_UNDER_8', label: '6만원 ~ 8만원' },
  { value: 'OVER_8_UNDER_10', label: '8만원 ~ 10만원' },
  { value: 'OVER_10_UNDER_12', label: '10만원 ~ 12만원' },
  { value: 'OVER_12', label: '12만원 이상' },
];

export const planTypes = [
  { label: 'LITE', value: 'LITE' },
  { label: 'PRO', value: 'PRO' },
];

// 회원앱 브랜딩(#188) — 이 지점과 연동한 회원앱에 보일 지점 범위
export const appBrandingTypes = [
  { label: '사용 안 함', value: 'NONE' },
  { label: '이 지점만', value: 'SELF' },
  { label: '같은 계열 전체', value: 'GROUP' },
];

// 라이트버전(ROLE_GUEST)에서 블러 안내로 차단되는 경로 목록 (MainLayout 블러 + LeftMenu Lite 배지 판단에 공용)
export const GUEST_RESTRICTED_PATHS = [
  '/chat',
  '/notice',
  '/event',
  '/banner',
  '/transfer',
  '/sms',
  '/salary',
  '/salarySettlement',
  '/facility-control',
  '/ticket',
  '/pass',
  '/product',
  '/locker',
  '/point-management',
  '/permission',
];
